/**
 * Product page variant selection and product media gallery.
 * The gallery is dependency-free so it works with Shopify product media,
 * stays fast, and keeps the first media item available server-side.
 */
(function () {
  function formatMoney(cents, product) {
    var value = (cents / 100).toFixed(2);
    var format = product.moneyFormat || (window.theme && window.theme.moneyFormat) || '${{amount}}';
    return format.replace(/\{\{\s*amount\s*\}\}/, value);
  }

  function ProductForm(root) {
    this.root = root;
    this.form = root.querySelector('[data-add-to-cart-form]');
    var dataEl = root.querySelector('[data-product-json]');
    if (!dataEl || !this.form) return;

    this.product = JSON.parse(dataEl.textContent);
    this.optionInputs = root.querySelectorAll('[data-option-input]');
    this.idInput = this.form.querySelector('input[name="id"]');
    this.priceEl = root.querySelector('[data-product-price]');
    this.submitBtn = this.form.querySelector('[data-add-to-cart-submit]');
    this.submitText = this.form.querySelector('[data-add-to-cart-text]');
    this.skuEl = root.querySelector('[data-product-sku]');
    this.gallery = root.querySelector('[data-product-gallery]');
    this.slides = this.gallery ? Array.prototype.slice.call(this.gallery.querySelectorAll('[data-gallery-slide]')) : [];
    this.activeIndex = this.slides.findIndex(function (slide) { return !slide.hidden; });
    this.activeIndex = this.activeIndex < 0 ? 0 : this.activeIndex;
    this.autoplayDelay = this.gallery ? parseInt(this.gallery.getAttribute('data-autoplay'), 10) || 0 : 0;
    this.autoplayTimer = null;
    this.dialog = this.gallery ? this.gallery.querySelector('[data-gallery-dialog]') : null;
    this.dialogImage = this.dialog ? this.dialog.querySelector('[data-dialog-image]') : null;
    this.dialogVideo = this.dialog ? this.dialog.querySelector('[data-dialog-video]') : null;
    var zoomInButton = this.dialog ? this.dialog.querySelector('[data-zoom-in]') : null;
    this.dialogTools = zoomInButton ? zoomInButton.closest('[role="toolbar"]') : null;
    this.zoomOutput = this.dialog ? this.dialog.querySelector('[data-zoom-level]') : null;
    this.zoom = 1;
    this.panX = 0;
    this.panY = 0;
    this.dragState = null;

    this.optionInputs.forEach(function (input) {
      input.addEventListener('change', this.onOptionChange.bind(this));
    }.bind(this));

    this.bindGallery();
  }

  ProductForm.prototype.bindGallery = function () {
    if (!this.gallery || !this.slides.length) return;

    this.gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', this.onThumbClick.bind(this));
    }.bind(this));
    this.gallery.querySelectorAll('[data-gallery-open]').forEach(function (openButton) {
      openButton.addEventListener('click', this.openDialog.bind(this));
    }.bind(this));

    var previous = this.gallery.querySelector('[data-gallery-previous]');
    var next = this.gallery.querySelector('[data-gallery-next]');
    if (previous) previous.addEventListener('click', this.previous.bind(this));
    if (next) next.addEventListener('click', this.next.bind(this));

    if (this.dialog) {
      this.dialog.querySelectorAll('[data-dialog-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', this.onThumbClick.bind(this));
      }.bind(this));
      var dialogPrevious = this.dialog.querySelector('[data-dialog-previous]');
      var dialogNext = this.dialog.querySelector('[data-dialog-next]');
      var close = this.dialog.querySelector('[data-gallery-close]');
      if (dialogPrevious) dialogPrevious.addEventListener('click', this.previous.bind(this));
      if (dialogNext) dialogNext.addEventListener('click', this.next.bind(this));
      if (close) close.addEventListener('click', this.closeDialog.bind(this));

      var zoomIn = this.dialog.querySelector('[data-zoom-in]');
      var zoomOut = this.dialog.querySelector('[data-zoom-out]');
      var zoomReset = this.dialog.querySelector('[data-zoom-reset]');
      if (zoomIn) zoomIn.addEventListener('click', function () { this.setZoom(this.zoom + 0.25); }.bind(this));
      if (zoomOut) zoomOut.addEventListener('click', function () { this.setZoom(this.zoom - 0.25); }.bind(this));
      if (zoomReset) zoomReset.addEventListener('click', this.resetZoom.bind(this));

      this.dialog.addEventListener('click', function (event) {
        if (event.target === this.dialog) this.closeDialog();
      }.bind(this));
      this.dialog.addEventListener('close', this.onDialogClosed.bind(this));
      this.dialog.addEventListener('cancel', function () { this.stopAutoplay(); }.bind(this));

      if (this.dialogImage) {
        this.dialogImage.addEventListener('wheel', function (event) {
          if (!this.dialog.open) return;
          event.preventDefault();
          this.setZoom(this.zoom + (event.deltaY < 0 ? 0.25 : -0.25));
        }.bind(this), { passive: false });
        this.dialogImage.addEventListener('dblclick', function () {
          this.setZoom(this.zoom > 1 ? 1 : 2);
        }.bind(this));
        this.dialogImage.addEventListener('pointerdown', this.startDrag.bind(this));
        this.dialogImage.addEventListener('pointermove', this.drag.bind(this));
        this.dialogImage.addEventListener('pointerup', this.endDrag.bind(this));
        this.dialogImage.addEventListener('pointercancel', this.endDrag.bind(this));
      }
    }

    this.gallery.addEventListener('mouseenter', this.stopAutoplay.bind(this));
    this.gallery.addEventListener('mouseleave', this.startAutoplay.bind(this));
    this.gallery.addEventListener('focusin', this.stopAutoplay.bind(this));
    this.gallery.addEventListener('focusout', function (event) {
      if (!this.gallery.contains(event.relatedTarget)) this.startAutoplay();
    }.bind(this));
    document.addEventListener('keydown', function (event) {
      if (!this.dialog || !this.dialog.open) return;
      if (event.key === 'ArrowLeft') { event.preventDefault(); this.previous(); }
      if (event.key === 'ArrowRight') { event.preventDefault(); this.next(); }
      if (event.key === '+' || event.key === '=') { event.preventDefault(); this.setZoom(this.zoom + 0.25); }
      if (event.key === '-') { event.preventDefault(); this.setZoom(this.zoom - 0.25); }
      if (event.key === '0') { event.preventDefault(); this.resetZoom(); }
    }.bind(this));

    this.setActiveMedia(this.slides[this.activeIndex].getAttribute('data-media-id'));
    this.startAutoplay();
  };

  ProductForm.prototype.getSelectedOptions = function () {
    var selected = [];
    this.optionInputs.forEach(function (input) {
      if (input.type === 'radio' || input.type === 'checkbox') {
        if (input.checked) selected[Number(input.dataset.optionPosition) - 1] = input.value;
      } else {
        selected[Number(input.dataset.optionPosition) - 1] = input.value;
      }
    });
    return selected;
  };

  ProductForm.prototype.findVariant = function (selectedOptions) {
    return this.product.variants.find(function (variant) {
      return variant.options.every(function (value, index) {
        return value === selectedOptions[index];
      });
    });
  };

  ProductForm.prototype.onThumbClick = function (event) {
    this.setActiveMedia(event.currentTarget.getAttribute('data-media-id'));
  };

  ProductForm.prototype.indexForMediaId = function (mediaId) {
    return this.slides.findIndex(function (slide) {
      return slide.getAttribute('data-media-id') === String(mediaId);
    });
  };

  ProductForm.prototype.setActiveMedia = function (mediaId) {
    if (!this.gallery) return;
    var index = this.indexForMediaId(mediaId);
    if (index < 0) return;
    this.activeIndex = index;

    this.gallery.querySelectorAll('video').forEach(function (video) {
      if (!this.slides[index].contains(video)) {
        video.pause();
        video.currentTime = 0;
      }
    }.bind(this));

    this.slides.forEach(function (slide, slideIndex) {
      slide.hidden = slideIndex !== index;
    });
    this.gallery.querySelectorAll('[data-gallery-thumb], [data-dialog-thumb]').forEach(function (thumb) {
      var isActive = thumb.getAttribute('data-media-id') === String(mediaId);
      thumb.classList.toggle('is-active', isActive);
      thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
      if (isActive && this.dialog && this.dialog.open && thumb.hasAttribute('data-dialog-thumb')) {
        thumb.scrollIntoView({ block: 'nearest', inline: 'center' });
      }
    }.bind(this));

    if (this.dialog && this.dialog.open) this.renderDialogMedia();
  };

  ProductForm.prototype.next = function () {
    if (!this.slides.length) return;
    var nextIndex = (this.activeIndex + 1) % this.slides.length;
    this.setActiveMedia(this.slides[nextIndex].getAttribute('data-media-id'));
  };

  ProductForm.prototype.previous = function () {
    if (!this.slides.length) return;
    var previousIndex = (this.activeIndex - 1 + this.slides.length) % this.slides.length;
    this.setActiveMedia(this.slides[previousIndex].getAttribute('data-media-id'));
  };

  ProductForm.prototype.startAutoplay = function () {
    if (this.autoplayTimer || this.autoplayDelay < 1000 || this.slides.length < 2 || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
    if (this.dialog && this.dialog.open) return;
    this.autoplayTimer = window.setInterval(this.next.bind(this), this.autoplayDelay);
  };

  ProductForm.prototype.stopAutoplay = function () {
    if (!this.autoplayTimer) return;
    window.clearInterval(this.autoplayTimer);
    this.autoplayTimer = null;
  };

  ProductForm.prototype.openDialog = function () {
    if (!this.dialog || (!this.dialogImage && !this.dialogVideo)) return;
    this.stopAutoplay();
    this.renderDialogMedia();
    if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
    else this.dialog.setAttribute('open', '');
    var close = this.dialog.querySelector('[data-gallery-close]');
    if (close) close.focus();
  };

  ProductForm.prototype.closeDialog = function () {
    if (!this.dialog) return;
    if (typeof this.dialog.close === 'function' && this.dialog.open) this.dialog.close();
    else this.dialog.removeAttribute('open');
    this.onDialogClosed();
  };

  ProductForm.prototype.onDialogClosed = function () {
    if (this.dialogVideo) {
      this.dialogVideo.pause();
      this.dialogVideo.removeAttribute('src');
      this.dialogVideo.load();
      this.dialogVideo.hidden = true;
    }
    this.resetZoom();
    this.startAutoplay();
  };

  ProductForm.prototype.renderDialogMedia = function () {
    if ((!this.dialogImage && !this.dialogVideo) || !this.slides[this.activeIndex]) return;
    var slide = this.slides[this.activeIndex];
    var image = slide.querySelector('img');
    var video = slide.querySelector('video');
    var isVideo = slide.getAttribute('data-media-kind') === 'video' || !!video;
    var source = slide.getAttribute('data-video-src') || slide.getAttribute('data-full-src') || (image && (image.currentSrc || image.src));

    if (this.dialogTools) this.dialogTools.hidden = isVideo;

    if (isVideo) {
      if (!source || !this.dialogVideo) return;
      if (this.dialogImage) {
        this.dialogImage.hidden = true;
        this.dialogImage.removeAttribute('src');
      }
      this.dialogVideo.hidden = false;
      this.dialogVideo.poster = video ? video.getAttribute('poster') || '' : '';
      this.dialogVideo.src = source;
      this.dialogVideo.load();
    } else {
      if (!source || !this.dialogImage) return;
      if (this.dialogVideo) {
        this.dialogVideo.pause();
        this.dialogVideo.hidden = true;
        this.dialogVideo.removeAttribute('src');
        this.dialogVideo.load();
      }
      this.dialogImage.hidden = false;
      this.dialogImage.src = source;
      this.dialogImage.alt = image ? image.alt : this.product.title;
    }

    var count = this.dialog.querySelector('[data-gallery-dialog-count]');
    if (count) count.textContent = (this.activeIndex + 1) + ' / ' + this.slides.length;
    this.resetZoom();
  };

  ProductForm.prototype.setZoom = function (value) {
    this.zoom = Math.max(1, Math.min(4, value));
    if (this.zoom === 1) { this.panX = 0; this.panY = 0; }
    if (this.dialogImage) {
      this.dialogImage.style.transform = 'translate(' + this.panX + 'px, ' + this.panY + 'px) scale(' + this.zoom + ')';
      this.dialogImage.classList.toggle('is-zoomed', this.zoom > 1);
    }
    if (this.zoomOutput) this.zoomOutput.textContent = Math.round(this.zoom * 100) + '%';
  };

  ProductForm.prototype.resetZoom = function () {
    this.panX = 0;
    this.panY = 0;
    this.setZoom(1);
  };

  ProductForm.prototype.startDrag = function (event) {
    if (this.zoom <= 1 || !this.dialogImage) return;
    this.dragState = { x: event.clientX, y: event.clientY, panX: this.panX, panY: this.panY };
    this.dialogImage.setPointerCapture(event.pointerId);
    this.dialogImage.classList.add('is-dragging');
  };

  ProductForm.prototype.drag = function (event) {
    if (!this.dragState) return;
    this.panX = this.dragState.panX + event.clientX - this.dragState.x;
    this.panY = this.dragState.panY + event.clientY - this.dragState.y;
    this.setZoom(this.zoom);
  };

  ProductForm.prototype.endDrag = function () {
    this.dragState = null;
    if (this.dialogImage) this.dialogImage.classList.remove('is-dragging');
  };

  ProductForm.prototype.onOptionChange = function () {
    var selected = this.getSelectedOptions();
    var variant = this.findVariant(selected);
    if (!variant) return;

    if (this.idInput) this.idInput.value = variant.id;

    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);

    if (this.priceEl) {
      var compareHtml = variant.compare_at_price > variant.price
        ? '<s class="price__compare">' + formatMoney(variant.compare_at_price, this.product) + '</s>'
        : '';
      var saleClass = variant.compare_at_price > variant.price ? ' price--on-sale' : '';
      this.priceEl.className = 'price' + saleClass;
      this.priceEl.innerHTML =
        '<span class="price__' + (compareHtml ? 'sale' : 'regular') + '">' + formatMoney(variant.price, this.product) + '</span>' + compareHtml;
    }

    if (this.skuEl) this.skuEl.textContent = variant.sku || '';
    if (this.submitBtn) this.submitBtn.disabled = !variant.available;
    if (this.submitText) {
      this.submitText.textContent = !variant.available
        ? this.submitText.getAttribute('data-sold-out-label')
        : this.submitText.getAttribute('data-available-label');
    }
    if (variant.featured_media) this.setActiveMedia(variant.featured_media.id);
  };

  document.querySelectorAll('[data-product-form-root]').forEach(function (root) {
    new ProductForm(root);
  });
})();
